import React, { FC } from 'react'

interface KeyboardControlIconsProps {
    children: React.ReactNode
}

export const KeyboardControlIcons: FC<KeyboardControlIconsProps> = ({ children }) => (
    <div className={'inline-flex align-middle'}>
        <div className={'font-bold border border-gray-300 rounded-sm bg-gray-100 p-0.5'}>{children}</div>
    </div>
)

interface MouseControlIconsProps {
    button: 'LMB' | 'RMB'
}

export const MouseControlIcons: FC<MouseControlIconsProps> = ({ button }) => (
    <div className={'inline-flex align-middle'}>
        <div className={'font-bold border border-gray-400 rounded-full bg-gray-200 h-6 w-4.5'}>
            <div className={'h-2.5 border-b border-gray-400 flex'}>
                <div
                    className={
                        'h-2.5 w-1/2 border-r border-gray-400 rounded-tl-full' +
                        (button === 'LMB' ? ' bg-amber-600' : '')
                    }
                />
                <div
                    className={
                        'h-2.5 w-1/2 border-l border-gray-400 rounded-tr-full' +
                        (button === 'RMB' ? ' bg-amber-600' : '')
                    }
                />
            </div>
        </div>
    </div>
)
